<template>
  <div>
    <div class="container">
      <e-search
        :data="filterInfo.data"
        :field-list="filterInfo.fieldList"
        :width="filterInfo.width"
        :list-type-info="listTypeInfo"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
      ></e-search>
    </div>
    <div class="container">
      <div class="tip"><span>提示：</span><span>您在进行转账时，请在备注信息或附言中备注收费通知书编号，感谢您的支持～</span></div>
      <tableList
        :loading="loading"
        :index-show="true"
        :table-data="tableData"
        row-key="chargeNoticeId"
        :table-label="tableLabel"
        style="margin-top: 20px"
      >
        <template v-slot:chargeAmount="{scope}">
          <div style="color: #E50113">{{scope.row.chargeAmount}}</div>
        </template>
        <template v-slot:businessNo="{scope}">
          <el-button style="font-size: 12px;padding-left: 0" type="text" @click="viewBusinessNo(scope.row)">查看
          </el-button>
        </template>
        <template v-slot:payerCompanyName="slot">
          <e-tooltip
            mode="width" :content="slot.scope.row.payerCompanyName"
          />
        </template>
        <template v-slot:operate="slot">
          <div class="font-12">
            <eui-btn
                    type="link"
                    font-size="12px"
                    v-if="slot.scope.row.paymentStatus === 1"
                    @click="toPayApprove"
                    style="font-size: 12px"
            >支付审批
            </eui-btn>
            <eui-btn
                    type="link"
                    font-size="12px"
                    @click="handleView(slot.scope.row)"
                    style="font-size: 12px"
            >查看
            </eui-btn
            >
            <eui-btn
              type="text"
              font-size="12px"
              v-if="[3].includes(slot.scope.row.chargeStatus) || [0,3].includes(slot.scope.row.paymentStatus)"
              @click="payment(slot.scope.row)"
            >去支付
            </eui-btn>
          </div>
        </template>
      </tableList>

      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="queryData.pageNum"
          :page-size="queryData.pageSize"
          :total="queryData.pageTotal"
          prev-text="上一页"
          next-text="下一页"
        ></el-pagination>
      </div>
    </div>
    <payment-dialog :visible.sync="payVisible" :info="info" @success="statementAccountBackPage()"/>
    <related-orders-dialog :visible.sync="visible" :info="info"/>
  </div>
</template>
<script>
import eSearch from '../../components/common/e-search';
import tableList from '../../components/common/e-table-list';
import api from '../../api/order';
import eTooltip from '../../components/common/e-tooltip';
import { businessTypeList, statusList, chargeTypeList,collectivePurchaseTypeList } from './commonData';
import paymentDialog from '@/modules/projectA/pages/noticeOfCharge/paymentDialog';
import relatedOrdersDialog from './relatedOrdersDialog';

export default {
  name: 'index',
  components: { eSearch, tableList, eTooltip, paymentDialog, relatedOrdersDialog },
  data() {
    return {
      loading: false,
      visible: false,
      payVisible: false,
      tableData: [],
      tableLabel: [
        {
          label: '收费通知书编号',
          param: 'chargeNoticeNo',
          align: 'center',
          width: '160'
        },
        {
          label: '付款单位',
          slot: 'payerCompanyName',
          align: 'center'
        },
        {
          label: '收费金额（元）',
          align: 'right',
          headerAlign: 'right',
          slot: 'chargeAmount',
          minWidth: 110
        },
        {
          label: '关联单据',
          align: 'center',
          slot: 'businessNo'
        },
        {
          label: '来源',
          param: 'businessType',
          align: 'center',
          render: ({ businessType }) => {
            return businessTypeList.find(item => businessType === item.id)?.name;
          }
        },
        {
          label: '收费类型',
          param: 'chargeType',
          align: 'center',
          render: ({ chargeType }) => {
            return chargeTypeList.find(item => chargeType === item.id)?.name;
          }
        },
        {
          label: '是否集采',
          param: 'collectivePurchaseType',
          align: 'center',
          width: '140',
          render:({ collectivePurchaseType })=> {
            if(Number(collectivePurchaseType) === 1){
              return  '是'
            }
            if(Number(collectivePurchaseType) === 0){
              return  '否'
            }
          }
        },
        {
          label: '状态',
          param: 'chargeStatus',
          align: 'center',
          render: ({ chargeStatus, paymentStatus, paymentType }) => {
            if (paymentType === 1) {
              if (paymentStatus === 1 || (paymentStatus === 2 && chargeStatus !== 2)) {
                return '支付中';
              } else if (paymentStatus === 3) {
                return '支付失败';
              }
            }
            return statusList.find(item => chargeStatus === item.id)?.name;
          }
        },
        {
          label: '创建时间',
          param: 'createTime',
          align: 'center',
          minWidth: 140
        },
        {
          label: '操作',
          align: 'center',
          fixed: 'right',
          slot: 'operate',
          width: '150'
        }
      ],
      queryData: {
        chargeNoticeNo: '',
        businessNo: '',
        businessType: null,
        chargeType: null,
        // 状态
        chargeStatus: null,
        collectivePurchaseType:null,
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0
      },
      filterInfo: {
        data: {
          chargeNoticeNo: '',
          businessNo: '',
          businessType: null,
          chargeType: null,
          // 状态
          chargeStatus: null,
          collectivePurchaseType:null,
        },
        fieldList: [
          { label: '收费通知书编号', type: 'input', value: 'chargeNoticeNo' },
          { label: '关联单据', type: 'input', value: 'businessNo', placeholder: '请输入关联单据编号' },
          {
            label: '来源',
            type: 'select',
            value: 'businessType',
            list: 'businessTypeList'
          },
          {
            label: '收费类型',
            type: 'select',
            value: 'chargeType',
            list: 'chargeTypeList'
          },
          {
            label: '状态',
            type: 'select',
            value: 'chargeStatus',
            list: 'statusList'
          },
          {
            label: '集采/非集采',
            type: 'select',
            value: 'collectivePurchaseType',
            list: 'collectivePurchaseTypeList',
          },

        ]
      },
      listTypeInfo: {
        chargeTypeList,
        businessTypeList,
        // 状态
        statusList,
        collectivePurchaseTypeList,
      },
      info: {}
    };
  },
  methods: {
    toPayApprove() {
      window.open('https://www.sinopecpay.com/', '_blank')
    },
    /**
     * 查看关联单号
     * @param data
     */
    viewBusinessNo(data) {
      this.info = data;
      this.visible = true;
    },
    payment(data) {
      this.info = data;
      this.payVisible = true;
    },
    handleSizeChange(val) {
      this.queryData.pageSize = val;
      this.queryData.pageNum = 1;
      this.statementAccountBackPage();
    },
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.statementAccountBackPage();
    },
    handleView(row) {
      this.$router.push({
        path: '/noticeOfChargeDetails',
        query: {
          chargeNoticeId: row.chargeNoticeId
        }
      });
    },
    handleFilter(val) {
      this.queryData = { ...this.queryData, ...val, pageNum: 1, pageTotal: undefined };
      this.statementAccountBackPage();
    },
    handleReset() {
      this.queryData = {
        statementAccountNo: '',
        businessNo: '',
        businessType: null,
        chargeType: null,
        // 状态
        chargeStatus: null,
        collectivePurchaseTypeList:null,
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0
      };
      this.statementAccountBackPage();
    },
    statementAccountBackPage() {
      this.loading = true;
      let params = {};
      if (this.queryData.chargeStatus === 6) {
        params.chargeStatus = null;
        params.paymentStatus = 1;
      } else if (this.queryData.chargeStatus === 5) {
        params.chargeStatus = null;
        params.paymentStatus = 3;
      } else if (this.queryData.chargeStatus === 0) {
        params.paymentStatus = 0;
      }
      api.getChargeNoticeSupplierList({
        ...this.queryData,
        ...params
      }).then((res) => {
        if (res.code === '200') {
          this.tableData = res.data.records;
          this.queryData.pageTotal = res.data.total;
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    }
  },
  mounted() {
    this.statementAccountBackPage();
  }
};
</script>

<style scoped lang="scss">
  .tip {
    font-family: Source Han Sans CN;
    height: 44px;
    line-height: 44px;
    background: #E8EFFF;
    font-size: 14px;
    padding-left: 10px;
    margin-top: 10px;

    > span:nth-child(1) {
      color: #F0250F;
    }

    > span:nth-child(2) {
      color: #333333;
    }
  }

  .line-box {
    display: flex;
  }

  .icon-wrapper {
    width: 30%;

    .right-line {
      border-right: 1px solid #8c939d;
      padding-right: 80px;
    }
  }

  ::v-deep .el-button--small {
    padding: 0 0 0 10px;
    margin-left: 0;
  }

  ::v-deep {
    .has-gutter {
      tr > th:nth-child(4) {
        text-align: right !important;
      }
    }
  }
</style>
